import entityService from './service.js'

const chunk = (arr, iteration, chunk) => {
  let start = iteration * chunk
  let end = start + chunk
  return arr.slice(start, end)
}

const chunks = (arr, chunkSize) => {
  let totalChunks = (arr.length / chunkSize)
  let chunks = []
  for (let i = 0; i < totalChunks; i++) {
    chunks.push(chunk(arr, i, chunkSize))
  }
  return chunks
}

export default {
  getEntity ({state, commit, rootState, dispatch}, {entity, id}) {
    return new Promise((resolve, reject) => {
      entityService.getEntityById(entity, id)
      .then(({data}) => {
        commit('SET_ENTITY', { entity, data })
        resolve()
      }).catch(err => {
        console.log(err)
        reject()
      })
    })
  },
  setDescriptorParent ({state, commit, rootState, dispatch}, id) {
    return new Promise((resolve, reject) => {
      commit('SET_PARENT_DESCRIPTOR', id)
      resolve()
    })
  },
  updateEntity ({state, commit, rootState, dispatch}, {entity, data}) {
    return new Promise((resolve, reject) => {
      commit('SET_ENTITY', { entity, data })
      resolve()
    })
  },
  updateLookupDetailsToggle ({state, commit}, bool) {
    return new Promise((resolve, reject) => {
      commit('SET_LOOKUP_DETAILS_TOGGLE', bool)
      resolve()
    })
  },
  massTariffRequestStatusUpdate ({state}, { status, tariffs, reason, effectiveTo }) {
    let promises = []
    let chunkSize = 50
    let splits = chunks(tariffs, chunkSize)
    splits.forEach(tariffIds => {
      const body = { status, tariffs: tariffIds, reason }
      if (effectiveTo) {
        body.effectiveTo = `${effectiveTo}T00:00:00.000Z`
      }
      promises.push(entityService.massTariffStatusUpdate(body))
    })
    return Promise.all(promises)
    /*
      return new Promise((resolve, reject) => {
        entityService.massTariffStatusUpdate(req).then(({data}) => resolve(data))
        .catch(err => reject(err))
      })
    */
  },
  cloneTariffRequest ({state}, id) {
    return new Promise((resolve, reject) => {
      entityService.cloneTariff(id).then(({data}) => resolve(data))
      .catch(err => reject(err))
    })
  },
  getVendorZoneLocations ({state, commit}, vendorZoneId) {
    return new Promise((resolve, reject) => {
      entityService.getEntities('vendor-zone-to-location', { vendorZone: vendorZoneId }, { 'X-Limit': '500', 'X-Page-Number': '1', 'X-Lazy-Fetch': '1' })
      .then(({data}) => {
        commit('SET_VENDOR_ZONE_LOCATIONS', data)
        resolve()
      })
      .catch(err => {
        commit('SET_VENDOR_ZONE_LOCATIONS', [])
        reject(err)
      })
    })
  },
  loadMoreVendorZoneLocations ({state, commit}, {vendorZoneId, page}) {
    return new Promise((resolve, reject) => {
      entityService.getEntities('vendor-zone-to-location',
        {
          vendorZone: vendorZoneId
        },
        {
          'X-Limit': '500',
          'X-Page-Number': String(page),
          'X-Lazy-Fetch': '1'
        })
        .then(({data}) => {
          commit('SET_VENDOR_ZONE_LOCATIONS', [...state.vendorZoneLocations, ...data])
          resolve()
        })
        .catch(err => {
          commit('SET_VENDOR_ZONE_LOCATIONS', [])
          reject(err)
        })
    })
  },
  getVendorZoneLocationsCount ({state, commit}, vendorZoneId) {
    return new Promise((resolve, reject) => {
      entityService.getEntitiesCount('vendor-zone-to-location', { vendorZone: vendorZoneId })
      .then(({data}) => {
        commit('SET_VENDOR_ZONE_LOCATIONS_COUNT', data.value)
        resolve()
      })
      .catch(err => {
        commit('SET_VENDOR_ZONE_LOCATIONS_COUNT', null)
        reject(err)
      })
    })
  },
  getPortAreaToPorts ({state, commit}, portAreaId) {
    return new Promise((resolve, reject) => {
      entityService.getEntities('port-area-to-port', { portArea: portAreaId })
      .then(({data}) => {
        commit('SET_PORT_AREA_TO_PORTS', data)
        resolve()
      })
      .catch(err => {
        commit('SET_PORT_AREA_TO_PORTS', [])
        reject(err)
      })
    })
  },
  getPointToPortToPorts ({state, commit}, pointToPortId) {
    return new Promise((resolve, reject) => {
      entityService.getEntities('point-to-port-to-port', { pointToPort: pointToPortId })
      .then(({data}) => {
        commit('SET_POINT_TO_POINT_TO_PORTS', data)
        resolve()
        })
      .catch(err => {
        commit('SET_POINT_TO_POINT_TO_PORTS', [])
        reject(err)
      })
    })
  },
  saveEntity ({state}, { entity, json }) {
    return entityService.saveEntity(entity, json)
  },
  deleteEntity ({state}, { entity, id }) {
    return entityService.deleteEntity(entity, id)
  }
}



// WEBPACK FOOTER //
// ./src/modules/admin/store/actions.js